module.exports = __webpack_public_path__ + "img/female_avatar.ba793d05.jpeg";